import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { breakpoints, colors, spacing } from '../../../utils/styleguide';
import Typography from '../text/Typography';

const TRANSITION_DURATION = '300ms';

const Wrapper = styled.div`
  align-items: center;
  background-color: ${colors.grey02};
  display: flex;
  height: ${spacing[8]}px;
  justify-content: space-around;
  position: relative;
  width: 100%;

  ${breakpoints.desktop} {
    height: ${spacing[8]}px;
  }
`;

const sliderTransition = ({ positionInPercentage }: { positionInPercentage: number }) =>
  css`
    transform: translateX(${positionInPercentage}%);
  `;

const Slider = styled.div`
  background-color: ${colors.purple400};
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  transition: transform ${TRANSITION_DURATION};
  width: 50%;
  z-index: 5;
  ${sliderTransition}
`;

const RadioButton = styled.input`
  position: absolute;
  appearance: none;
  background-color: transparent;
  border: none;
  height: 100%;
  margin: 0;
  outline: none;
  text-align: center;
  width: 100%;
  z-index: 15;
`;

const optionTextTransition = ({ color }: { color: string }) =>
  css`
    color: ${color};
  `;

const OptionText = styled(Typography)`
  line-height: 1;
  color: ${colors.black};
  transition: color ${TRANSITION_DURATION};
  ${optionTextTransition}
`;

const ButtonWrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
  width: 100%;
  height: ${spacing[8]}px;
`;

export type Option = { value: string; label: string };

type Props = {
  className?: string;
  value: string;
  onChange: (value: string) => void;
  options: [Option, Option];
};

const Switch = ({ className, value, onChange, options }: Props) => {
  function handleToggle(clickedValue: string) {
    if (value !== clickedValue) {
      onChange(clickedValue);
    }
  }

  return (
    <Wrapper className={className}>
      <Slider positionInPercentage={value === options[1].value ? 100 : 0} />

      <ButtonWrapper>
        <RadioButton
          type="radio"
          name="options"
          value={options[0].value}
          onChange={() => handleToggle(options[0].value)}
        />
        <OptionText
          color={value === options[0].value ? colors.white : colors.darkGray}
          variant="overlineBold"
        >
          {options[0].label}
        </OptionText>
      </ButtonWrapper>

      <ButtonWrapper>
        <RadioButton
          type="radio"
          name="options"
          value={options[1].value}
          onChange={() => handleToggle(options[1].value)}
        />
        <OptionText
          color={value === options[1].value ? colors.white : colors.darkGray}
          variant="overlineBold"
        >
          {options[1].label}
        </OptionText>
      </ButtonWrapper>
    </Wrapper>
  );
};

export default Switch;
